import React from 'react';
import Icon, { Props } from '../icon';

export const FavoriteOutlineDisabled = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3484 9.95699L20.5 10.8185L19.6514 9.95686C18.1042 8.3851 15.991 7.5 13.7855 7.5C11.5801 7.5 9.46686 8.3851 7.91971 9.95686C4.69343 13.2723 4.69343 18.5537 7.91971 21.8692L16.9075 30.9952C17.855 31.9578 19.1493 32.4999 20.5 32.4999C21.8508 32.4999 23.145 31.9578 24.0926 30.9952L33.0803 21.8693C36.3066 18.5539 36.3066 13.2724 33.0803 9.95701C31.5331 8.3852 29.4199 7.50006 27.2144 7.50005C25.0089 7.50005 22.8956 8.38518 21.3484 9.95699Z"
        stroke="#F2F2F2"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default React.memo(FavoriteOutlineDisabled);
